/** Bilingual dictionary — every UI string. Never hardcode strings in components. */
export const dict = {
  en: {
    app_name: "Kirana Books",
    tagline: "Bilingual billing for your shop",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email_or_phone: "Email or phone",
    password: "Password",
    name: "Name",
    phone: "Phone",
    email: "Email",
    role: "Role",
    owner: "Owner",
    staff: "Staff",
    dashboard: "Dashboard",
    items: "Items",
    billing: "Billing",
    bills: "Bills",
    new_bill: "New bill",
    photo_bill: "Photo → Bill",
    purchases: "Purchases",
    customers: "Customers",
    suppliers: "Suppliers",
    reports: "Reports",
    settings: "Settings",
    language: "Language",
    english: "English",
    gujarati: "ગુજરાતી",
    today_sales: "Today's sales",
    month_sales: "Month sales",
    pending_credit: "Pending credit",
    stock_value: "Stock value",
    low_stock: "Low stock",
    bills_today: "Bills today",
    add_item: "Add item",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    name_en: "Name (English)",
    name_gu: "Name (ગુજરાતી)",
    unit: "Unit",
    cost_price: "Cost price",
    selling_price: "Selling price",
    stock: "Stock",
    quantity: "Qty",
    rate: "Rate",
    amount: "Amount",
    total: "Total",
    subtotal: "Subtotal",
    discount: "Discount",
    paid: "Paid",
    balance: "Balance",
    status: "Status",
    partial: "Partial",
    credit: "Credit",
    customer: "Customer",
    supplier: "Supplier",
    notes: "Notes",
    create_bill: "Create bill",
    add_row: "Add row",
    upload_order: "Upload order photo / file",
    upload_help: "JPG, PNG, PDF, DOCX, XLSX or CSV. Handwritten Gujarati / English.",
    read_with_ai: "Read with AI",
    reading: "Reading order sheet…",
    engine_used: "Read by",
    expected_vs_returned: "Lines detected",
    review_edit: "Review & edit",
    review_help: "Every detected line is shown below. Fix the flagged rows before creating the bill.",
    needs_check: "Needs check",
    cancelled: "Cancelled",
    original_line: "Original line",
    match_catalog: "Match catalog",
    unmatched: "New item",
    incomplete_row: "Row incomplete — fill name and quantity",
    view_pdf: "View PDF",
    download_pdf: "Download PDF",
    print: "Print",
    search: "Search",
    empty_items: "No items yet. Add your first item.",
    empty_bills: "No bills yet.",
    bulk_customer: "Bulk order customer",
    add_customer: "Add customer",
    add_supplier: "Add supplier",
    address: "Address",
    running_balance: "Running balance",
    new_purchase: "New purchase",
    demo_owner: "Owner login:  owner@kirana.local  /  owner123",
    demo_staff: "Staff login:  staff@kirana.local  /  staff123",
    confirm_delete: "Are you sure? This cannot be undone.",
    yes_delete: "Yes, delete",
    read_failed: "Could not read the file. Please try a clearer photo.",
    bill_created: "Bill created",
    item_saved: "Item saved",
    signed_in_as: "Signed in as",
    hi: "Hi",
    pick_from_catalog: "Pick from catalog",
    or_type_new: "or type a new item",
    warning: "Warning",
    line_count_mismatch: "Line count mismatch",
    all_flagged_reviewed: "Review all flagged rows to continue",
    logo_letter: "K",
    scan_barcode: "Scan barcode",
    scanning: "Scanning…",
    barcode_not_found: "No item with this barcode",
    barcode_unsupported: "Camera scanning not supported on this browser. Type the code below.",
    enter_barcode: "Type barcode",
    barcode: "Barcode",
    templates: "Templates",
    save_as_template: "Save as template",
    use_template: "Use template",
    template_name: "Template name",
    template_saved: "Template saved",
    pick_template: "Pick a template",
    no_templates: "No templates yet. Save a bill as template to reuse.",
    share_whatsapp: "Share on WhatsApp",
    share_pdf: "Share PDF",
    whatsapp_summary: "Hi {name}, here is your bill {no} for ₹{total}. Thank you!",
    offline_ready: "Ready for offline",
    offline_now: "You are offline — showing cached data",
    otp: "OTP",
    otp_tab: "OTP login",
    password_tab: "Password",
    send_otp: "Send OTP",
    otp_sent: "OTP sent",
    verify_otp: "Verify",
    demo_otp_notice: "Demo mode: your OTP is",
    resend_otp: "Resend OTP",
    otp_placeholder: "6-digit code",
    voice_add: "Voice add",
    voice_hint: "Say 'two kg rice, half kg sugar…'",
    listening: "Listening…",
    processing_voice: "Understanding…",
    voice_no_lines: "Nothing understood. Please try again.",
    stop_recording: "Stop",
    voice_transcript: "You said",
    shops: "Shops",
    add_shop: "Add shop",
    shop_name: "Shop name",
    switch_shop: "Switch shop",
    current_shop: "Current shop",
    delete_shop: "Delete shop",
    main_shop: "Main Shop",
    print_labels: "Print labels",
    labels_count: "How many labels?",
    print: "Print",
    cash_drawer: "Cash Drawer",
    todays_cash: "Today's cash",
    cash_in: "Cash in",
    cash_out: "Cash out",
    net_cash: "Net",
    add_entry: "Add entry",
    entry_type: "Type",
    entry_amount: "Amount",
    entry_category: "Category",
    entry_note: "Note",
    cat_sale: "Sale",
    cat_purchase: "Purchase",
    cat_expense: "Expense",
    cat_opening: "Opening",
    cat_adjustment: "Adjustment",
    cat_other: "Other",
    no_entries_yet: "No cash movement yet today.",
    auto_logged: "Auto-logged",
    manual_entry: "Manual",
    record_return: "Record return",
    return_receipt: "Return receipt",
    return_qty: "Return qty",
    max_qty: "max",
    return_total: "Total return",
    refund_amount: "Refund now (cash out)",
    return_notes: "Reason / notes",
    submit_return: "Confirm return",
    returns: "Returns",
    no_returns: "No returns yet.",
    over_return: "Cannot return more than remaining",
    return_created: "Return recorded",
    view_return: "View return",
    z_report: "Z-Report",
    z_report_hint: "End-of-day printable summary",
    download_z_report: "Download Z-Report",
    pick_date: "Pick date",
    net_sales: "Net sales",
    return_count: "Returns",
    top_by_qty: "Top by quantity",
    top_by_amount: "Top by revenue",
    no_results: "No results",
    create_new_item: "Create new item",
    create_new_customer: "Create new customer",
    create_new_supplier: "Create new supplier",
    bulk_from_photo: "Bulk from photo",
    bulk_items_title: "Add items from a stock-list photo",
    bulk_items_help: "Upload a photo/PDF of your price or stock list. AI will read every row — review and edit before creating.",
    upload_stock_list: "Upload stock list",
    review_items: "Review items",
    create_items: "Create {count} items",
    no_items_found: "No items detected. Try a clearer photo.",
    items_created: "{count} items created",
    delete_purchase: "Delete this purchase?",
    delete_purchase_confirm: "This will remove the purchase, revert stock, and delete its cash-drawer entry. This cannot be undone.",
    whatsapp_inbox: "WhatsApp inbox",
    wa_inbox_title: "Turn WhatsApp orders into draft bills",
    wa_inbox_help: "Drop or upload photos your customers sent on WhatsApp. Each photo becomes an editable draft bill.",
    wa_add_orders: "Add order photos",
    wa_empty_help: "Save the WhatsApp order photos to your phone and upload them here. AI reads them all in parallel.",
    wa_reading: "Reading",
    wa_ready: "Ready",
    wa_drafted: "Drafted",
    wa_reading_msg: "Reading with AI…",
    wa_ready_msg: "{n} lines detected · review and draft",
    wa_created_msg: "Draft bill created",
    no_lines_detected: "No lines detected in this photo.",
    create_draft_bill: "Create draft bill",
    draft_created: "Draft bill created",
    open_bill: "Open bill",
    optional: "optional",
    name_required: "Please enter the item name (English or Gujarati)",
    all: "All",
    no_purchases: "No purchases yet",
    no_purchases_in_month: "No purchases in this month",
    top_suppliers: "Top suppliers",
    unpaid: "Unpaid",
    select_all: "Select all",
    clear: "Clear",
    mark_paid: "Mark paid",
    mark_paid_confirm: "Mark {n} bill(s) as fully paid and log ₹{amount} to the cash drawer?",
    original_photo: "Original photo",
    tier_vip: "VIP",
    tier_regular: "Regular",
    collect_pending: "Collect pending",
    showing_pending_bills: "Showing {n} pending bill(s)",
    show_all_bills: "Show all bills",
    filter: "filter",
    pwa_install_title: "Install Kirana Books on your phone",
    pwa_install_help: "Add to home screen for faster access and offline billing.",
    install: "Install",
    add_user: "Add new user",
    role_owner: "Owner",
    role_staff: "Staff",
    create_user: "Create user",
    user_added: "{name} added — they can now log in",
    add_user_missing: "Name + password + email or phone are required",
    bill_marked_paid: "Bill marked paid",
    logout: "Log out",
    role: "Role",
    email: "Email",
    phone: "Phone",
    users_list: "Users in your shop",
    reset_password: "Reset password",
    new_password: "New password",
    pw_min: "Password must be at least 4 characters",
    pw_updated: "Password updated",
    nudge_wa: "Nudge on WhatsApp",
    sync_debug: "Sync debug",
    sync_debug_help: "Last 20 API calls with timing. Useful when cross-device sync feels off.",
    show: "Show",
    hide: "Hide",
    no_data: "no calls yet",
  },
  gu: {
    app_name: "કિરાણા બુક્સ",
    tagline: "તમારી દુકાન માટે દ્વિભાષી બિલિંગ",
    login: "લોગ ઇન",
    register: "નોંધણી",
    logout: "લોગ આઉટ",
    email_or_phone: "ઈમેલ અથવા ફોન",
    password: "પાસવર્ડ",
    name: "નામ",
    phone: "ફોન",
    email: "ઈમેલ",
    role: "ભૂમિકા",
    owner: "માલિક",
    staff: "કર્મચારી",
    dashboard: "ડેશબોર્ડ",
    items: "વસ્તુઓ",
    billing: "બિલિંગ",
    bills: "બિલ",
    new_bill: "નવું બિલ",
    photo_bill: "ફોટો → બિલ",
    purchases: "ખરીદી",
    customers: "ગ્રાહકો",
    suppliers: "સપ્લાયર",
    reports: "રિપોર્ટ",
    settings: "સેટિંગ્સ",
    language: "ભાષા",
    english: "English",
    gujarati: "ગુજરાતી",
    today_sales: "આજનું વેચાણ",
    month_sales: "માસિક વેચાણ",
    pending_credit: "બાકી ઉધાર",
    stock_value: "સ્ટોક મૂલ્ય",
    low_stock: "ઓછો સ્ટોક",
    bills_today: "આજના બિલ",
    add_item: "વસ્તુ ઉમેરો",
    edit: "સંપાદિત",
    delete: "કાઢી નાખો",
    save: "સાચવો",
    cancel: "રદ કરો",
    confirm: "પુષ્ટિ",
    name_en: "નામ (English)",
    name_gu: "નામ (ગુજરાતી)",
    unit: "એકમ",
    cost_price: "ખર્ચ ભાવ",
    selling_price: "વેચાણ ભાવ",
    stock: "સ્ટોક",
    quantity: "જથ્થો",
    rate: "ભાવ",
    amount: "રકમ",
    total: "કુલ",
    subtotal: "પેટા કુલ",
    discount: "કપાત",
    paid: "ચૂકવેલ",
    balance: "બાકી",
    status: "સ્થિતિ",
    partial: "અધૂરું",
    credit: "ઉધાર",
    customer: "ગ્રાહક",
    supplier: "સપ્લાયર",
    notes: "નોંધ",
    create_bill: "બિલ બનાવો",
    add_row: "પંક્તિ ઉમેરો",
    upload_order: "ઓર્ડરનો ફોટો / ફાઈલ અપલોડ કરો",
    upload_help: "JPG, PNG, PDF, DOCX, XLSX અથવા CSV. હાથે લખેલું ગુજરાતી / અંગ્રેજી.",
    read_with_ai: "AI થી વાંચો",
    reading: "ઓર્ડર વાંચી રહ્યા છીએ…",
    engine_used: "વાંચ્યું",
    expected_vs_returned: "શોધેલી પંક્તિઓ",
    review_edit: "તપાસો અને સુધારો",
    review_help: "દરેક શોધાયેલી પંક્તિ નીચે છે. બિલ બનાવતા પહેલા ફ્લેગ કરેલી પંક્તિઓ સુધારો.",
    needs_check: "તપાસ જરૂરી",
    cancelled: "રદ",
    original_line: "મૂળ પંક્તિ",
    match_catalog: "કેટલોગ સાથે મેળવો",
    unmatched: "નવી વસ્તુ",
    incomplete_row: "અધૂરી પંક્તિ — નામ અને જથ્થો ભરો",
    view_pdf: "PDF જુઓ",
    download_pdf: "PDF ડાઉનલોડ",
    print: "છાપો",
    search: "શોધો",
    empty_items: "હજી કોઈ વસ્તુ નથી. પ્રથમ વસ્તુ ઉમેરો.",
    empty_bills: "હજી કોઈ બિલ નથી.",
    bulk_customer: "બલ્ક ઓર્ડર ગ્રાહક",
    add_customer: "ગ્રાહક ઉમેરો",
    add_supplier: "સપ્લાયર ઉમેરો",
    address: "સરનામું",
    running_balance: "ચાલુ બાકી",
    new_purchase: "નવી ખરીદી",
    demo_owner: "માલિક લોગિન:  owner@kirana.local  /  owner123",
    demo_staff: "કર્મચારી લોગિન:  staff@kirana.local  /  staff123",
    confirm_delete: "શું તમે ચોક્કસ છો? આ પાછું નહીં આવે.",
    yes_delete: "હા, કાઢી નાખો",
    read_failed: "ફાઇલ વાંચી શકાઈ નહીં. વધુ સ્પષ્ટ ફોટો અજમાવો.",
    bill_created: "બિલ બન્યું",
    item_saved: "વસ્તુ સાચવી",
    signed_in_as: "લોગ ઇન તરીકે",
    hi: "નમસ્તે",
    pick_from_catalog: "કેટલોગમાંથી પસંદ કરો",
    or_type_new: "અથવા નવી વસ્તુ લખો",
    warning: "ચેતવણી",
    line_count_mismatch: "પંક્તિ ગણતરી મેળ ખાતી નથી",
    all_flagged_reviewed: "ચાલુ રાખવા બધી ફ્લેગ પંક્તિઓ તપાસો",
    logo_letter: "કિ",
    scan_barcode: "બારકોડ સ્કેન કરો",
    scanning: "સ્કેન થઈ રહ્યું છે…",
    barcode_not_found: "આ બારકોડ સાથે કોઈ વસ્તુ નથી",
    barcode_unsupported: "કેમેરા સ્કેન સપોર્ટેડ નથી. કોડ નીચે લખો.",
    enter_barcode: "બારકોડ લખો",
    barcode: "બારકોડ",
    templates: "ટેમ્પલેટ્સ",
    save_as_template: "ટેમ્પલેટ તરીકે સાચવો",
    use_template: "ટેમ્પલેટ વાપરો",
    template_name: "ટેમ્પલેટ નામ",
    template_saved: "ટેમ્પલેટ સાચવ્યું",
    pick_template: "ટેમ્પલેટ પસંદ કરો",
    no_templates: "હજી કોઈ ટેમ્પલેટ નથી. બિલને ટેમ્પલેટ તરીકે સાચવો.",
    share_whatsapp: "વોટ્સએપ પર મોકલો",
    share_pdf: "PDF શેર કરો",
    whatsapp_summary: "નમસ્તે {name}, તમારું બિલ {no} ₹{total} નું છે. આભાર!",
    offline_ready: "ઓફલાઈન માટે તૈયાર",
    offline_now: "તમે ઓફલાઈન છો — કેશ્ડ ડેટા બતાવી રહ્યા છીએ",
    otp: "OTP",
    otp_tab: "OTP થી લોગ ઇન",
    password_tab: "પાસવર્ડ",
    send_otp: "OTP મોકલો",
    otp_sent: "OTP મોકલ્યો",
    verify_otp: "ચકાસો",
    demo_otp_notice: "ડેમો મોડ: તમારો OTP છે",
    resend_otp: "ફરી મોકલો",
    otp_placeholder: "6 અંકનો કોડ",
    voice_add: "બોલીને ઉમેરો",
    voice_hint: "કહો 'બે કિલો ચોખા, અડધો કિલો ખાંડ…'",
    listening: "સાંભળી રહ્યા છીએ…",
    processing_voice: "સમજી રહ્યા છીએ…",
    voice_no_lines: "કંઈ સમજાયું નહીં. ફરી પ્રયાસ કરો.",
    stop_recording: "બંધ",
    voice_transcript: "તમે કહ્યું",
    shops: "દુકાનો",
    add_shop: "દુકાન ઉમેરો",
    shop_name: "દુકાનનું નામ",
    switch_shop: "દુકાન બદલો",
    current_shop: "વર્તમાન દુકાન",
    delete_shop: "દુકાન કાઢી નાખો",
    main_shop: "મુખ્ય દુકાન",
    print_labels: "લેબલ છાપો",
    labels_count: "કેટલા લેબલ?",
    cash_drawer: "કેશ ડ્રોઅર",
    todays_cash: "આજની રોકડ",
    cash_in: "જમા",
    cash_out: "ઉધાર",
    net_cash: "કુલ",
    add_entry: "એન્ટ્રી ઉમેરો",
    entry_type: "પ્રકાર",
    entry_amount: "રકમ",
    entry_category: "શ્રેણી",
    entry_note: "નોંધ",
    cat_sale: "વેચાણ",
    cat_purchase: "ખરીદી",
    cat_expense: "ખર્ચ",
    cat_opening: "ઓપનિંગ",
    cat_adjustment: "ગોઠવણ",
    cat_other: "અન્ય",
    no_entries_yet: "આજે હજી કોઈ રોકડ હિલચાલ નથી.",
    auto_logged: "સ્વયં નોંધાયું",
    manual_entry: "મેન્યુઅલ",
    record_return: "રિટર્ન નોંધો",
    return_receipt: "રિટર્ન રસીદ",
    return_qty: "પરત જથ્થો",
    max_qty: "મહત્તમ",
    return_total: "કુલ પરત",
    refund_amount: "રોકડ પરત",
    return_notes: "કારણ / નોંધ",
    submit_return: "રિટર્ન પુષ્ટિ",
    returns: "રિટર્ન",
    no_returns: "હજી કોઈ રિટર્ન નથી.",
    over_return: "બાકી કરતાં વધુ પરત ન કરી શકાય",
    return_created: "રિટર્ન નોંધાયું",
    view_return: "રિટર્ન જુઓ",
    z_report: "Z-રિપોર્ટ",
    z_report_hint: "દિવસ અંતનો પ્રિન્ટેબલ સારાંશ",
    download_z_report: "Z-રિપોર્ટ ડાઉનલોડ",
    pick_date: "તારીખ પસંદ કરો",
    net_sales: "નેટ વેચાણ",
    return_count: "રિટર્ન",
    top_by_qty: "જથ્થા પ્રમાણે ટોપ",
    top_by_amount: "આવક પ્રમાણે ટોપ",
    no_results: "કોઈ પરિણામ નથી",
    create_new_item: "નવો આઇટમ બનાવો",
    create_new_customer: "નવો ગ્રાહક બનાવો",
    create_new_supplier: "નવો સપ્લાયર બનાવો",
    bulk_from_photo: "ફોટોથી બલ્ક",
    bulk_items_title: "સ્ટોક-લિસ્ટ ફોટોથી આઇટમ ઉમેરો",
    bulk_items_help: "તમારી કિંમત કે સ્ટોક લિસ્ટનો ફોટો/PDF અપલોડ કરો. AI દરેક પંક્તિ વાંચશે — બનાવતા પહેલા સમીક્ષા અને સંપાદન કરો.",
    upload_stock_list: "સ્ટોક લિસ્ટ અપલોડ કરો",
    review_items: "આઇટમ સમીક્ષા",
    create_items: "{count} આઇટમ બનાવો",
    no_items_found: "કોઈ આઇટમ મળ્યું નથી. વધુ સ્પષ્ટ ફોટો અજમાવો.",
    items_created: "{count} આઇટમ બન્યા",
    delete_purchase: "આ ખરીદી કાઢી નાખવી?",
    delete_purchase_confirm: "આનાથી ખરીદી હટશે, સ્ટોક રિવર્ટ થશે, અને કેશ-ડ્રોઅર એન્ટ્રી કાઢી નાખશે. આ ફેરવી શકાતું નથી.",
    whatsapp_inbox: "વ્હોટ્સએપ ઇનબોક્સ",
    wa_inbox_title: "વ્હોટ્સએપ ઓર્ડરને ડ્રાફ્ટ બિલમાં ફેરવો",
    wa_inbox_help: "ગ્રાહકો દ્વારા વ્હોટ્સએપ પર મોકલેલા ફોટા અહીં ડ્રોપ કરો. દરેક ફોટો સંપાદનયોગ્ય ડ્રાફ્ટ બિલ બને છે.",
    wa_add_orders: "ઓર્ડર ફોટા ઉમેરો",
    wa_empty_help: "વ્હોટ્સએપ ઓર્ડર ફોટા ફોનમાં સેવ કરી અહીં અપલોડ કરો. AI એકસાથે વાંચશે.",
    wa_reading: "વાંચી રહ્યું છે",
    wa_ready: "તૈયાર",
    wa_drafted: "ડ્રાફ્ટ થયું",
    wa_reading_msg: "AI વાંચી રહ્યું છે…",
    wa_ready_msg: "{n} લાઇન મળી · સમીક્ષા અને ડ્રાફ્ટ કરો",
    wa_created_msg: "ડ્રાફ્ટ બિલ બનાવ્યું",
    no_lines_detected: "આ ફોટામાંથી કોઈ લાઇન મળી નથી.",
    create_draft_bill: "ડ્રાફ્ટ બિલ બનાવો",
    draft_created: "ડ્રાફ્ટ બિલ બનાવ્યું",
    open_bill: "બિલ ખોલો",
    optional: "વૈકલ્પિક",
    name_required: "કૃપા કરી આઇટમનું નામ લખો (અંગ્રેજી અથવા ગુજરાતી)",
    all: "બધા",
    no_purchases: "હજુ કોઈ ખરીદી નથી",
    no_purchases_in_month: "આ મહિનામાં કોઈ ખરીદી નથી",
    top_suppliers: "મુખ્ય સપ્લાયર",
    unpaid: "બાકી",
    select_all: "બધા પસંદ કરો",
    clear: "સાફ",
    mark_paid: "ચૂકવ્યું ચિહ્નિત કરો",
    mark_paid_confirm: "{n} બિલને પૂરું ચૂકવેલું ચિહ્નિત કરી ₹{amount} કેશ-ડ્રોઅરમાં નોંધવું?",
    original_photo: "મૂળ ફોટો",
    tier_vip: "VIP",
    tier_regular: "નિયમિત",
    collect_pending: "બાકી વસૂલો",
    showing_pending_bills: "{n} બાકી બિલ બતાવી રહ્યું",
    show_all_bills: "બધા બિલ બતાવો",
    filter: "ફિલ્ટર",
    pwa_install_title: "ફોનમાં Kirana Books ઇન્સ્ટોલ કરો",
    pwa_install_help: "હોમ સ્ક્રીન પર ઉમેરો — ઝડપી અને ઓફલાઇન બિલિંગ.",
    install: "ઇન્સ્ટોલ",
    add_user: "નવો વપરાશકર્તા ઉમેરો",
    role_owner: "માલિક",
    role_staff: "કર્મચારી",
    create_user: "વપરાશકર્તા બનાવો",
    user_added: "{name} ઉમેરાયા — હવે લોગ ઇન કરી શકે છે",
    add_user_missing: "નામ + પાસવર્ડ + ઇમેઇલ/ફોન જરૂરી",
    bill_marked_paid: "બિલ ચૂકવેલું ચિહ્નિત",
    logout: "લોગ આઉટ",
    role: "ભૂમિકા",
    email: "ઇમેઇલ",
    phone: "ફોન",
    users_list: "તમારા દુકાનના વપરાશકર્તાઓ",
    reset_password: "પાસવર્ડ રીસેટ",
    new_password: "નવો પાસવર્ડ",
    pw_min: "પાસવર્ડ ઓછામાં ઓછો 4 અક્ષર",
    pw_updated: "પાસવર્ડ અપડેટ થયો",
    nudge_wa: "વ્હોટ્સએપ પર યાદ કરાવો",
    sync_debug: "સિંક ડિબગ",
    sync_debug_help: "છેલ્લી 20 API કૉલ સમય સાથે. ક્રોસ-ડિવાઇસ સિંક તપાસવા માટે.",
    show: "બતાવો",
    hide: "છુપાવો",
    no_data: "હજી કોઈ કૉલ નથી",
  },
};

export function guToLatin(s) {
  if (!s) return s;
  const map = { "૦": "0", "૧": "1", "૨": "2", "૩": "3", "૪": "4", "૫": "5", "૬": "6", "૭": "7", "૮": "8", "૯": "9" };
  return String(s).replace(/[૦-૯]/g, (c) => map[c] || c);
}
